<template>
    <v-menu v-if="pcOnly" v-model="notificationsMenu" :close-on-content-click="false" :offset-y="true" left transition="slide-y-transition"> <!-- fade-up -->
        <template v-slot:activator="{}">
            <v-btn v-haptic icon :color="!!newNotifications ? 'strong-text' : 'text'" class="icon-wrapper" :large="large" @click.prevent="openNotifications">
                <v-badge class="notification-badge" :value="!!newNotifications" color="ebadge" bordered :content="newNotifications" overlap right>
                    <v-icon size="26">{{newNotifications ? 'mdi-bell-ring' : 'mdi-bell-outline' }}</v-icon>
                </v-badge>
            </v-btn>
        </template>
        <v-list width="400" max-height="600">
            <div class="d-flex justify-space-between pb-2 px-4 align-center">
                <div class="medium-text">اﻹشعارات</div>
                <div class="details-text" :class="{'primary--text': unseenCount, 'grey--text': !unseenCount}">{{unseenText}}</div>
            </div>

            <v-divider />
            
            <vue-custom-scrollbar class="scroll-area" :wheelPropagation="false" :scrollingThreshold="500">
                <div class="notifications-wrapper">
                    <div v-for="notification in notifications" :key="notification.id" class="notification-wrapper">
                        <notification :notification="notification" />
                    </div>
                </div>

                <div class="d-flex justify-center align-center mt-2">
                    <v-btn text small :disabled="!existsMore" color="primary darken-2" @click="showMore = true">عرض المزيد من اﻹشعارات</v-btn>
                </div>
            </vue-custom-scrollbar>
            
        </v-list>
    </v-menu>
    <div v-else>
        <v-btn v-haptic icon color="text" class="icon-wrapper" :large="large" @click.prevent="openNotifications">
            <v-badge class="notification-badge" :value="!!newNotifications" color="secondary" bordered :content="newNotifications" overlap right>
                <v-icon color="text" size="26">{{newNotifications ? 'mdi-bell-ring' : 'mdi-bell-outline' }}</v-icon>
            </v-badge>
        </v-btn>

        <page-dialog v-model="notificationsMenu" title="اﻹشعارات" icon="mdi-bell-outline">
            <!-- copied - from top lines -->
            <div v-for="notification in notifications" :key="notification.id" class="notification-wrapper">
                <notification :notification="notification" />
            </div>

            <div v-if="existsMore" class="d-flex justify-center align-center mt-2">
                <v-btn text small :disabled="!existsMore" color="primary darken-2" @click="showMore = true">عرض المزيد من اﻹشعارات</v-btn>
            </div>
        </page-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import Notification from '../../default/notification'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import PageDialog from '@/components/default/dialogs/page-dialog'

// import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        large: {type: Boolean, default: false}
    },
    data(){
        return {
            notificationsMenu: false,
            showMore: false,
            limit: 10,
        }
    },
    components: {
        Notification,
        vueCustomScrollbar,
        PageDialog
    },
    computed: {
        ...GlobalComputed,
        existsMore(){
            return this.allNotifications.length > this.notifications.length;
        },
        notifications(){
            let notifications = this.allNotifications;
            if (!notifications){
                return [];
            }
            return this.showMore ? notifications : notifications.slice(0, this.limit);
        },
        allNotifications(){
            return this.user.notifications;
        },
        unseenCount(){
            let unseen = this.allNotifications.filter(n=>{
                return !n.read;
            });
            return unseen.length;
        },
        unseenText(){
            let count = this.unseenCount;
            if (count){
                if (count){
                    return 'إشعار واحد جديد';
                }else if (count){
                    return 'إشعاران جديدان'
                }else if (count <= 10){
                    return `${count} إشعارات جديدة`
                }else{
                    return `${count} إشعار جديد`
                }
            }
            return 'لا يوجد جديد';
        },
        newNotifications(){
            let unread = this.user.notifications_count;
            // let unread = 122;
            return unread > 99 ? '+99' : unread;
        },
    },
    methods: {
        markAllAsRead(){
            if (this.user.notifications_count > 0){
                this.$store.dispatch('markAllAsRead');
            }
        },
        openNotifications(){
            if (this.notifications.length){
                this.notificationsMenu= !this.notificationsMenu;
                window.setTimeout(()=>{
                    this.markAllAsRead();
                }, 2000);
            }
        }
    }
}
</script>

<style lang="scss">

    .scroll-area {
        position: relative;
        margin: auto;
        max-height: 500px!important;
    }

    .notification-badge.v-badge--bordered .v-badge__badge{
        font-weight: bold;
        &::after{
            // right: 2px!important;
        }
    }
</style>